/**
 * @ngdoc service
 * @name fileTypes
 * @description
 * This service stores the regular expressions to validate the supported files,
 * and provides different ways to check if the mime types or file extensions are supported.
 *
 * @memberof common
 */
class FileTypes {
  /**
   * Class constructor.
   * @ignore
   */
  constructor() {
    /**
     * Regular expression to validate video file extension
     * @type {RegExp}
     */
    this.videoExtensionRegex = /\.(avi|flv|wmv|mov|mp4)$/i;
    /**
     * Regular expression to validate the images supported mime types
     * @type {RegExp}
     */
    this.imageExtensionRegex = /image\/(jpg|jpeg|png|gif)$/i;
    /**
     * Regular expression to validate the supported mime types
     * @type {RegExp}
     */
    // eslint-disable-next-line max-len
    this.supportedMimeTypesRegex = /(application\/(pdf|postscript|psd|ai|octet-stream|x-photoshop))|(image\/(jpg|jpeg|png|gif|tiff|vnd.adobe.photoshop))|(video\/(x-msvideo|avi|flv|x-flv|wmv|x-ms-wmv|mov|mp4|quicktime))$/i;
  }
  /**
   * Checks if the given filename is a valid(supported) video file extension
   * @param  {String}  filename The filename with extension to validate
   * @return {Boolean}
   */
  hasAVideoExtension(filename) {
    return this.videoExtensionRegex.test(filename);
  }
  /**
   * Checks if the given mime type is a valid(supported) image file type
   * @param  {String}  type The mime type to validate
   * @return {Boolean}
   */
  isAnImageType(type) {
    return this.imageExtensionRegex.test(type);
  }
  /**
   * Checks if the given mime type is a valid(supported) file type
   * @param  {String}  type The mime type to validate
   * @return {Boolean}
   */
  isASupportedFileType(type) {
    return this.supportedMimeTypesRegex.test(type);
  }
}

export default FileTypes;



// WEBPACK FOOTER //
// ./src/frontend/modules/common/services/fileTypes.js